module.exports = "<button class=\"btn btn-warning\" ng-click=adminHotelEditBarCtrl.cancelChanges()>Cancel</button> <button class=\"btn btn-kt\" ng-disabled=!adminHotelEditBarCtrl.isDataModified ng-click=adminHotelEditBarCtrl.saveChanges()>Save</button>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-bar/admin-hotel-edit-bar.html
// module id = 629
// module chunks = 0